<template>
  <div class="row-article-name">
    <img
      v-if="data.icon"
      :src="data.icon | s3url"
    />
    <div>{{ data.name }}</div>
  </div>
</template>
  
<script>
export default {
  name: "row-article-name",
  props: {
    data: {
      type: Object,
    },
  },
};
</script>

<style lang="scss">
.row-article-name {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  img {
    width: 80px;
    height: 80px;
    border-radius: 8px;
    object-fit: cover;
    margin-bottom: 2px;
  }
}
</style>